import { createSelector } from "reselect";

export const Types = {
  GET_REQUEST: "points/GET_REQUEST",
  GET_SUCCESS: "points/GET_SUCCESS",
  GET_FAILURE: "points/GET_FAILURE",

  GET_LIST_REQUEST: "points/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "points/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "points/GET_LIST_FAILURE",

  CREATE_REQUEST: "points/CREATE_REQUEST",
  CREATE_SUCCESS: "points/CREATE_SUCCESS",
  CREATE_FAILURE: "points/CREATE_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },
};

export default function points(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.point.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.points.data,
        page: action.payload.points.meta.current_page,
        totals: action.payload.points.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getPointRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getPointSuccess: (point) => ({
    type: Types.GET_SUCCESS,
    payload: { point },
  }),

  getPointFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getPointsRequest: (page) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getPointsSuccess: (points) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { points },
  }),

  getPointsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createPointRequest: (data) => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createPointSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createPointFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),
};

export const Selectors = {
  points: createSelector(
    (state) => state,
    (points) =>
      points.map((point) => ({
        ...point,
        attributes: {
          ...point.attributes,
          // cpfs: {
          //   ...point.attributes.cpfs,
          // },
        },
      }))
  ),
};
